export default __webpack_public_path__ + "static/media/2.68cf2775.png";